/**
 * @flow
 * @relayHash a2f89985718cd19b38f20a8af8b1f91c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddSolicitationContractorsInput = {|
  solicitationId: string,
  contractorIds?: ?$ReadOnlyArray<?string>,
  contractorGroupId?: ?string,
  clientMutationId?: ?string,
|};
export type AddSolicitationContractorsMutationVariables = {|
  input: AddSolicitationContractorsInput
|};
export type AddSolicitationContractorsMutationResponse = {|
  +addSolicitationContractors: ?{|
    +isUpdated: ?boolean,
    +solicitation: ?{|
      +id: string,
      +numberOfContractors: ?number,
    |},
  |}
|};
export type AddSolicitationContractorsMutation = {|
  variables: AddSolicitationContractorsMutationVariables,
  response: AddSolicitationContractorsMutationResponse,
|};
*/


/*
mutation AddSolicitationContractorsMutation(
  $input: AddSolicitationContractorsInput!
) {
  addSolicitationContractors(input: $input) {
    isUpdated
    solicitation {
      id
      numberOfContractors
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddSolicitationContractorsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addSolicitationContractors",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddSolicitationContractorsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isUpdated",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "solicitation",
        "storageKey": null,
        "args": null,
        "concreteType": "SolicitationNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numberOfContractors",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddSolicitationContractorsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddSolicitationContractorsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddSolicitationContractorsMutation",
    "id": null,
    "text": "mutation AddSolicitationContractorsMutation(\n  $input: AddSolicitationContractorsInput!\n) {\n  addSolicitationContractors(input: $input) {\n    isUpdated\n    solicitation {\n      id\n      numberOfContractors\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37a416e5efc720d23c69e6b63ebfb86f';
module.exports = node;
